"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginStatus;
(function (LoginStatus) {
    LoginStatus[LoginStatus["EXPIRED"] = 0] = "EXPIRED";
    LoginStatus[LoginStatus["FAILED"] = 1] = "FAILED";
    LoginStatus[LoginStatus["NEED_VERIFICATION"] = 2] = "NEED_VERIFICATION";
    LoginStatus[LoginStatus["VERIFICATION_CODE_INCORRECT"] = 3] = "VERIFICATION_CODE_INCORRECT";
    LoginStatus[LoginStatus["SUCCESS"] = 4] = "SUCCESS";
    LoginStatus[LoginStatus["BLOCKED"] = 5] = "BLOCKED";
})(LoginStatus = exports.LoginStatus || (exports.LoginStatus = {}));
//# sourceMappingURL=login-status.enum.js.map